<template>
  <div
    v-if="$store.getters.isLoggedIn"
    id="user-form-page"
    class="page">
    <!-- Drawer -->
    <v-navigation-drawer
      v-model="isDrawerOpen"
      :width="drawerWidth"
      mobile-break-point="1024"
      floating
      app>
      <div class="page-logo-container mx-auto my-5">
        <PosmLogo />
      </div>

      <v-spacer></v-spacer>

      <!-- User Account Menu -->
      <UserMenu class="mt-auto" />
      <!-- User Account Menu -->
    </v-navigation-drawer>
    <!-- / Drawer -->

    <!-- User Form Page Content -->
    <v-content>
      <v-toolbar>
        <v-app-bar-nav-icon
          class="page-drawer-toggle mr-0"
          @click="isDrawerOpen = !isDrawerOpen">
        </v-app-bar-nav-icon>

        <v-toolbar-title
          class="pl-0">
          <MainNavigationMenu />
        </v-toolbar-title>
      </v-toolbar>

      <!-- User Form -->
      <UserForm
        class="page-content mx-5"
      />
      <!-- / User Form -->
    </v-content>
    <!-- / User Form Page Content -->
  </div>
</template>

<script>
import PosmLogo from '../components/PosmLogo.vue';
import MainNavigationMenu from '../components/MainNavigationMenu.vue';
import UserMenu from '../components/UserMenu.vue';
import UserForm from '../components/UserForm.vue';

export default {
  name: 'UserFormPage',
  components: {
    PosmLogo,
    MainNavigationMenu,
    UserMenu,
    UserForm,
  },
};
</script>

<style lang="scss"></style>
